import { render, staticRenderFns } from "./WidgetImportSettings.vue?vue&type=template&id=75c0fba6&"
import script from "./WidgetImportSettings.vue?vue&type=script&lang=js&"
export * from "./WidgetImportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
